/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../../client/js/components/NoData'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import CustomerListItem from './CustomerListItem'

export type CustomerListProps = {
  items: Customer[]
}

function CustomerList (props: CustomerListProps) {
  const { items } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th style={{ width: 50 }}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th scope="col">
            <FormattedMessage
              id="name_and_firstname"
              defaultMessage="Nom et prénom"
            />
          </Table.Th>
          <Table.Th
            scope="col"
            style={{ width: 150 }}
          >
            <FormattedMessage
              id="mobile"
              defaultMessage="Mobile"
            />
          </Table.Th>
          <Table.Th
            scope="col"
            style={{ width: 150 }}
          >
            <FormattedMessage
              id="phone"
              defaultMessage="Téléphone"
            />
          </Table.Th>
          <Table.Th scope="col">
            <FormattedMessage
              id="email"
              defaultMessage="Email"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <CustomerListItem
              item={item}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={6}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default CustomerList
